import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import PriceChangeRoundedIcon from '@mui/icons-material/PriceChangeRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import HomeIcon from '@mui/icons-material/Home';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, useLocation } from 'react-router-dom';
import { useContent } from '../../../../context/ContentContext'; // Ensure correct import path

const mainMenuItems = [
  { label: 'Koneksi & Top 3', icon: <HomeRoundedIcon />, route: '/connection' },
  { label: 'Produk Mark', icon: <Inventory2RoundedIcon />, route: '/products' },
  { label: 'Alamat Mark', icon: <LocationOnRoundedIcon />, route: '/address' },
  { label: 'Marketing Kit', icon: <CampaignRoundedIcon />, route: '/marketing-kit' },
  { label: 'Pemesanan', icon: <ShoppingCartRoundedIcon />, route: '/booking' },
  { label: 'List Harga', icon: <PriceChangeRoundedIcon />, route: '/price-list' },
  { label: 'FAQ', icon: <HelpOutlineRoundedIcon />, route: '/faq' },
  { label: 'Bantuan', icon: <SupportAgentRoundedIcon />, route: '/bantuan' },
];

const secondaryMenuItems = [
  { label: 'Home', icon: <HomeIcon />, route: '/home' },
  { label: 'Rekrut Agen', icon: <PersonAddIcon />, route: '/recruit-agent' },
  { label: 'Transaksi', icon: <PaymentIcon />, route: '/transaction' },
  { label: 'Profile', icon: <AccountCircleIcon />, route: '/profile' },
  { label: 'Logout', icon: <LogoutIcon />, action: 'logout' }, // Add Logout
];

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logoutUser } = useContent(); // Destructure logoutUser from context

  const getSelectedIndex = (items) =>
    items.findIndex((item) => item.route === location.pathname);

  const handleNavigation = (route) => {
    navigate(route);
  };

  const handleLogout = () => {
    // Call logoutUser from context to handle the logout logic
    logoutUser();
  };

  const handleAction = (item) => {
    if (item.action === 'logout') {
      handleLogout();
    } else {
      handleNavigation(item.route);
    }
  };

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      {/* Main Menu Items */}
      <List dense>
        {mainMenuItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={getSelectedIndex(mainMenuItems) === index}
              onClick={() => handleNavigation(item.route)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* Secondary Menu Items */}
      <List dense>
        {secondaryMenuItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={getSelectedIndex(secondaryMenuItems) === index}
              onClick={() => handleAction(item)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
